module.exports = __webpack_public_path__ + "img/picked_up.07aea9c9.png";